module.exports = __webpack_public_path__ + "img/image19.66ab996e.jpg";